export default __webpack_public_path__ + "static/media/pixel.2d816bfe.png";